import axios from 'axios'

const ZipCodeApi = axios.create({
  baseURL: 'https://viacep.com.br/ws',
})

export default ZipCodeApi
